/** @format */

import React from 'react';
import TemplateButton from './TemplateButton.js';
import PropTypes from 'prop-types';
import { ReactComponent as Tick } from '../../assets/themes/OPL/img/icons/Tick.svg';
import { ReactComponent as Cancel } from '../../assets/themes/OPL/img/icons/Cancel.svg';

function AcceptButton({ ...props }) {
    const { accepted, classes, callback, callbackParam, tooltipTitle, tooltipPlacement, color, text, ...rest } = props;
    return (
        <TemplateButton
            {...rest}
            className={classes}
            tooltipTitle={tooltipTitle}
            tooltipPlacement={tooltipPlacement}
            classes={classes}
            icon={accepted ? Cancel : Tick}
            color={color}
            callback={callback}
            callbackParam={callbackParam}
            text={text}
        />
    );
}

AcceptButton.propTypes = {
    callback: PropTypes.func.isRequired,
    callbackParam: PropTypes.object.isRequired,
    color: PropTypes.string,
    text: PropTypes.string,
};

export default AcceptButton;
